// test641
(641 && 0);
